// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationHomeSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.694 6.243a.5.5 0 0 1 .618 0l7.493 5.897a.5.5 0 0 1 .191.393v5.554a3 3 0 0 1-3 3h-2.5a.5.5 0 0 1-.5-.5V15.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v5.087a.5.5 0 0 1-.5.5h-2.5a3 3 0 0 1-3-3v-5.555a.5.5 0 0 1 .191-.393z"
    />
    <path
      fill="currentColor"
      d="m2.726 11.374-.626-.833a.5.5 0 0 1 .09-.692L9.74 3.867l.002.003.391-.309a3 3 0 0 1 3.724 0l.39.309.002-.003 1.746 1.384v-.664a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2.248l3.806 3.014a.5.5 0 0 1 .089.692l-.626.833a.5.5 0 0 1-.64.138L12.93 5.457a1.5 1.5 0 0 0-1.854 0l-7.713 6.057a.5.5 0 0 1-.637-.14z"
    />
  </svg>
);
export default SvgNavigationHomeSolid;
